import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 10px;
  user-select: none;
`;

export const Chart = styled.div`
  display: grid;
  overflow: auto;
  max-height: 70vh;
  


  div.gantt-month-period {
    position: sticky;
    top: 0;
    z-index: 10000;
  }
  
  div.gantt-row-item{
    border: 1px solid #D3d3d3;

  }
    
  div.gantt-day-period{
    border: 1px solid #D3d3d3;

    text-align: left;
    //padding: 10px 0 10px 0;

    span {
      display: inline-block;
    }
  }

  
  #currentDate{
    background-color: #40e5a0;
    border-radius: 4px;
    font-weight: bold;

  
  }

  div.gantt-row-period {
    display: grid;
    grid-auto-flow: column; //Celulas uma do lado da outra
    grid-auto-columns: ${({ theme }) => theme.cellWidth};
    grid-auto-rows: ${({ theme }) => theme.cellHeight};



  }

  div.all-days {
    position: sticky;
    top: 27px;
    z-index: 10001;
  }

  div.gantt-row-resource {
    position: sticky;
    left: 0;


    z-index: 9999;
    border: 1px solid #D3d3d3;

  div{
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    flex-direction: column;
    

  }


  }

  div.top-left-month{

    z-index: 10000;
    border: none;
    top: 0px;
    background-color: #fff;
  }

  div.top-left-day{


    z-index: 10000;
    top: 27px;

  
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 6px;
 
  }

  ::-webkit-scrollbar-thumb {
    background: #118052;
    width: 10px;
    border-radius: 6px;
  }
`;
